var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0244 0H3.99264C2.22363 0 0.788086 1.43961 0.788086 3.20455V16.7954C0.788086 18.5645 2.2277 20 3.99264 20H12.0244C13.7934 20 15.2289 18.5604 15.2289 16.7954V3.20862C15.2289 1.43961 13.7893 0.00406679 12.0244 0.00406679V0ZM12.7889 16.7954C12.7889 17.2184 12.4473 17.56 12.0244 17.56H3.99264C3.56971 17.56 3.2281 17.2143 3.2281 16.7954V3.20862C3.2281 2.78569 3.56971 2.44408 3.99264 2.44408H12.0244C12.4473 2.44408 12.7889 2.78975 12.7889 3.20862V16.7995V16.7954Z",
    fill: "#ba120e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.39292 14.4001H7.62431C6.94923 14.4001 6.4043 14.9451 6.4043 15.6202C6.4043 16.2952 6.94923 16.8402 7.62431 16.8402H8.39292C9.06799 16.8402 9.61292 16.2952 9.61292 15.6202C9.61292 14.9451 9.06799 14.4001 8.39292 14.4001Z",
    fill: "#ba120e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF5);
export default __webpack_public_path__ + "static/media/f5.a57b2abd7fc7880e68edacd55032736b.svg";
export { ForwardRef as ReactComponent };